<template>
  <v-dialog v-model="visible" persistent>
    <v-form ref="form">
      <div class="pa-5">
        <h1 class="mb-5" :class="{ 'title-error': titleColor === 'error' }">{{title}}</h1>
        <div class="my-5">
          <slot>
            <FormatSpan :value="message" />
          </slot>
        </div>
        <div class="d-flex justify-end">
          <v-btn :color="reverseColors ? 'primary' : 'error'" @click="close" v-if="type === 'confirm'">
            <v-icon>mdi-close</v-icon>
            {{cancelText}}
          </v-btn>
          <v-btn :color="reverseColors ? 'error' : 'primary'" class="ml-4" @click="ok">
            {{ okText }}
          </v-btn>
        </div>
      </div>
    </v-form>
  </v-dialog>
</template>

<script>
import FormatSpan from '../shared/FormatSpan.vue'

export default {
  components: {
    FormatSpan
  },
  computed: {
    dialog () {
      return this.$store.getters.confirmDialog
    },
    visible: {
      get () { return !!this.$store.getters.confirmDialog },
      set (v) { this.$store.commit('hideConfirmDialog', v) }
    },
    message () {
      return this.dialog?.message
    },
    title () {
      return this.dialog?.title || ''
    },
    cancelText () {
      return this.dialog?.cancelText || 'キャンセル'
    },
    okText () {
      return this.dialog?.okText || 'OK'
    },
    type () {
      return this.dialog?.type
    },
    reverseColors () {
      return this.dialog?.reverseColors
    },
    titleColor () {
      return this.dialog?.titleColor
    },
  },
  methods: {
    close () {
      this.visible = false
    },
    ok () {
      this.$store.commit('confirmDialogOkClick')
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 28px;
  color: #212121 !important;
  font-weight: bold;
}

h1.title-error {
  color: #ff5252 !important;
}

::v-deep {
  .v-dialog {
    width: 480px;
    background-color: white;
    border-radius: 9px;
  }
}
</style>
